module.exports = __webpack_public_path__ + "img/45.1fa61580.1fa61580.svg";